<template>
    <section>
        <div class="wrapper wrapper-content animated fadeInRight">
            <div class="row" v-if="!isLatLngAlreadySaved">
                <div class="col-md-12">
                    <div class="ibox-title">
                        <h4><center>Please Share Your Location With Us For Smooth Delivery Of Your FOOD!</center></h4>
                    </div>
                    <div class="ibox-content">
                        <div class="row">
                            <div class="col-md-12">
                                <div class="widget lazur-bg p-lg text-center" id="currentLocation" @click="getCurrentLocation()">
                                    <div class="m-b-md">
                                        <i class="fa fa-location-arrow fa-4x"></i>
                                        <h1 class="font-bold no-margins">
                                            Select Location
                                        </h1>
                                    </div>
                                </div> 
                            </div>
                        </div>
                        <div  class="row" v-if="marker.lat!==0.0">
                            <center><button type="submit" class="btn btn-primary" @click="saveLocation()">Submit Your Location <i class="fa fa-share-square fa-lg"></i></button></center><br>
                        </div>

                        <div class="row" v-show="marker.lat!==0.0">
                            <div class="col-md-12">
                                <div class="search-place-map">
                                    <gmap-autocomplete
                                    class="form-control"
                                    @place_changed="setAddress">
                                    </gmap-autocomplete>
                                </div>
                            </div>
                            <br><br>
                            <gmap-map
                                :options="{
                                zoomControl: true,
                                mapTypeControl: false,
                                }"
                                :center="center"
                                :zoom="zoom"
                                style="width:100%;  height: 500px;"
                                @click="addMarker($event)" ref="map"
                                >
                                <gmap-marker
                                :position="marker"
                                ></gmap-marker>
                            </gmap-map> 

                        </div>
                    </div>
                </div>
            </div>
            <div v-else>
                <center>
                    <h1><b>You Location Has Been Saved. <br> Thank You</b></h1>
                </center>
            </div>
        </div>
    </section>
</template>

<script>
    /* eslint-disable */

    export default {
        name: "CustomerLocation",
        data() {
            return {
                center: { lat: 31.5204, lng: 74.3587 },
                marker:{
                    lat:0.0,
                    lng:0.0
                },      
                zoom:12,
                currentLocation: false,
                customerAddressId: "",
                isLatLngAlreadySaved:false
            };
        },
        mounted: async function () {
            $("body").addClass("gray-bg");
            if(this.$route.query.customer_address_id !== undefined){
                this.customerAddressId= this.$route.query.customer_address_id;
                console.log("id" + this.customerAddressId);
            }
            await this.checkLatLngAlreadySaved();
        },
        methods: {          
            getCurrentLocation: function(){
                $(".widget").removeClass("yellow-bg");
                $('#currentLocation').addClass("yellow-bg");
                    Swal.fire({
                        title: 'Please Wait! We are getting your Location.',
                        type: 'info',
                        allowOutsideClick: false,
                        allowEscapeKey: false,
                        onBeforeOpen: () => {
                            Swal.showLoading();
                        },
                    });                
                this.currentLocation= true;
                let self= this;
                navigator.geolocation.getCurrentPosition(
                    position => {
                        this.center= {lat: position.coords.latitude, lng: position.coords.longitude}
                        self.marker.lat= position.coords.latitude;
                        self.marker.lng= position.coords.longitude;
                        self.zoom= 15;
                        Swal.close();
                    },
                    error => {
                    console.log(error.message);
                    Swal.close();
                    },{enableHighAccuracy:true, timeout:60000, maximumAge:600000}
                )                 
            },
            addMarker(event){
                this.marker.lat=event.latLng.lat();
                this.marker.lng= event.latLng.lng();
                this.zoom=15;                    
            },   
            setAddress(address) {
                this.zoom=12;
                this.selectedAddress = address;
                if(this.selectedAddress.geometry!==undefined){
                    this.center= {lat: this.selectedAddress.geometry.location.lat(), lng: this.selectedAddress.geometry.location.lng()}
                    this.marker.lat=this.selectedAddress.geometry.location.lat();
                    this.marker.lng= this.selectedAddress.geometry.location.lng();
                }
            },
            saveLocation(){
                Swal.fire({
                    title: 'Please Wait! We are processing the data.',
                    type: 'info',
                    allowOutsideClick: false,
                    allowEscapeKey: false,
                    onBeforeOpen: () => {
                        Swal.showLoading();
                    },
                });                
                let params= new URLSearchParams();
                params.append("customer_address_id", this.customerAddressId);
                params.append("exact_lat", this.marker.lat);
                params.append("exact_lng", this.marker.lng);
                this.$http.put(this.$store.state.mainAppURL + "customers/update_customer_lat_lng", params).then(resp=>{
                    Swal.close();
                    swal("Saved!", "Your Location Has Been Saved. Thank You", "success");
                    this.isLatLngAlreadySaved= true;
                })
            },
            async checkLatLngAlreadySaved(){
                const resp= await this.$http.get(this.$store.state.mainAppURL + "customers/check_exact_lat_lng_of_customer_address/" + this.customerAddressId);
                this.isLatLngAlreadySaved= resp.data       
            }
        }

    }
</script>

<style scoped>

</style>
